/* eslint-disable react/prop-types */
import { Box, Grid, Typography } from "@mui/material";
import FormField from "components/FormField";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { Form, Formik } from "formik";
import React from "react";
import TaxPersonalTable from "./components/table";
import initialValues from "./schema/initialValues";
import validation from "./schema/validations";
import form from "./schema/form";
import SoftButton from "components/SoftButton";
import SoftBox from "components/SoftBox";
import Loading from "components/Common/Loading";
import DatepickerField from "components/DatepickerField";
import SwitchField from "components/SwitchField";
import ModalCommon from "components/Modal";
import ModalContent from "./components/modalContent";
import Tabs from "./components/tabs";
import Actions from "./components/actions";
import SelectField from "components/SelectField";
import Footer from "./components/footer";

export default function Land01() {
  const [open, setOpen] = React.useState(true);
  const [tab, setTab] = React.useState(0);
  const { formId, formField } = form;

  const handleSubmit = async (values, action) => {
    console.log({ values });
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      {!open && (
        <>
          <Tabs tab={tab} setTab={setTab} />
          <Actions />
        </>
      )}
      <ModalCommon open={open} setOpen={setOpen} content={<ModalContent />}>
        {tab === 0 && (
          <Box display="flex" flexDirection="column" pb={10} gap={3}>
            <Box textAlign="center">
              <Typography variant="h4" textTransform="uppercase">
                Tờ khai thuế sử dụng đất nông nghiệp (Mẫu 01/SDDNN)
              </Typography>
              <Typography variant="subtitle1" fontStyle="italic" fontSize={14}>
                (Áp dụng đối với tổ chức có đất chịu thuế)
              </Typography>
            </Box>
            <Formik
              initialValues={initialValues}
              validationSchema={validation}
              onSubmit={handleSubmit}
            >
              {({ values, errors, touched, isSubmitting, setFieldValue }) => (
                <Form id={formId} autoComplete="off">
                  <Fields
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <TaxPersonalTable
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                    setFieldValue={setFieldValue}
                  />
                  <Fields2
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <Footer
                    formData={{
                      values,
                      touched,
                      formField,
                      errors,
                    }}
                  />
                  <SoftBox display="flex" justifyContent="flex-end" gap={3}>
                    <SoftButton
                      disabled={isSubmitting}
                      type="submit"
                      variant="gradient"
                      color="dark"
                    >
                      {isSubmitting ? <Loading width={25} height={25} /> : "Gửi"}
                    </SoftButton>
                  </SoftBox>
                </Form>
              )}
            </Formik>
          </Box>
        )}
      </ModalCommon>
    </DashboardLayout>
  );
}

const cityOption = [
  { value: "cityA", label: "Thành phố A" },
  { value: "cityB", label: "Thành phố B" },
  { value: "cityC", label: "Thành phố C" },
  { value: "cityD", label: "Thành phố D" },
];
const districtOption = [
  { value: "district", label: "Quận A" },
  { value: "district", label: "Quận B" },
  { value: "district", label: "Quận C" },
  { value: "district", label: "Quận D" },
];
const wardOption = [
  { value: "ward", label: "Phường A" },
  { value: "ward", label: "Phường B" },
  { value: "ward", label: "Phường C" },
  { value: "ward", label: "Phường D" },
];
function Fields({ formData }) {
  const { formField, values, errors, touched } = formData;
  const {
    period,
    firstTime,
    additional,
    taxpayerName,
    taxId,
    city,
    district,
    ward,
    village,
    road,
    apartment,
    taxAgentName,
    taxAgentId,
    taxAgentContract,
    daytaxAgentContract,
  } = formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "m-YY",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={period.name}
            label={period.label}
            error={errors.period && touched.period}
            success={values.period?.toString().length > 0 && !errors.period}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SwitchField name={firstTime.name} label={firstTime.label} value={values.firstTime} />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={additional.name}
            label={additional.label}
            value={values.additional}
            error={errors.additional && touched.additional}
            success={values.additional?.toString().length > 0 && !errors.additional}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxpayerName.name}
            label={taxpayerName.label}
            value={values.taxpayerName}
            error={errors.taxpayerName && touched.taxpayerName}
            success={values.taxpayerName?.toString().length > 0 && !errors.taxpayerName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxId.name}
            label={taxId.label}
            value={values.taxId}
            error={errors.taxId && touched.taxId}
            success={values.taxId?.toString().length > 0 && !errors.taxId}
          />
        </Grid>
        <Grid item xs={12} style={{ paddingTop: 0 }}>
          <Typography
            fontSize={13}
            marginLeft={0.5}
            fontWeight={"bold"}
            minWidth={210}
            whiteSpace="nowrap"
          >
            [06] Địa chỉ trụ sở:
          </Typography>
        </Grid>
        {/* //////////////////////// */}
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={cityOption}
            type={city.type}
            label={city.label}
            name={city.name}
            value={values.city}
            placeholder={city.placeholder}
            error={errors.city && touched.city}
            success={values.city.length > 0 && !errors.city}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={districtOption}
            type={district.type}
            label={district.label}
            name={district.name}
            value={values.district}
            placeholder={district.placeholder}
            error={errors.district && touched.district}
            success={values.district.length > 0 && !errors.district}
          />
        </Grid>
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <SelectField
            options={wardOption}
            type={ward.type}
            label={ward.label}
            name={ward.name}
            value={values.ward}
            placeholder={ward.placeholder}
            error={errors.ward && touched.ward}
            success={values.ward.length > 0 && !errors.ward}
          />
        </Grid>{" "}
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={village.name}
            label={village.label}
            value={values.village}
            error={errors.village && touched.village}
            success={values.village?.toString().length > 0 && !errors.village}
          />
        </Grid>{" "}
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={road.name}
            label={road.label}
            value={values.road}
            error={errors.road && touched.road}
            success={values.road?.toString().length > 0 && !errors.road}
          />
        </Grid>{" "}
        <Grid item xs={4} style={{ paddingTop: 0 }}>
          <FormField
            name={apartment.name}
            label={apartment.label}
            value={values.apartment}
            error={errors.apartment && touched.apartment}
            success={values.apartment?.toString().length > 0 && !errors.apartment}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentName.name}
            label={taxAgentName.label}
            value={values.taxAgentName}
            error={errors.taxAgentName && touched.taxAgentName}
            success={values.taxAgentName?.toString().length > 0 && !errors.taxAgentName}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentId.name}
            label={taxAgentId.label}
            value={values.taxAgentId}
            error={errors.taxAgentId && touched.taxAgentId}
            success={values.taxAgentId?.toString().length > 0 && !errors.taxAgentId}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={taxAgentContract.name}
            label={taxAgentContract.label}
            value={values.taxAgentContract}
            error={errors.taxAgentContract && touched.taxAgentContract}
            success={values.taxAgentContract?.toString().length > 0 && !errors.taxAgentContract}
          />
        </Grid>{" "}
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <FormField
            name={daytaxAgentContract.name}
            label={daytaxAgentContract.label}
            value={values.daytaxAgentContract}
            error={errors.daytaxAgentContract && touched.daytaxAgentContract}
            success={
              values.daytaxAgentContract?.toString().length > 0 && !errors.daytaxAgentContract
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
}
function Fields2({ formData }) {
  const { formField, values, errors, touched } = formData;
  const { startingTime, timeOfChange, taxExemption, compulsoryTax, taxPrice, taxMustBePaid } =
    formField;
  return (
    <Box display="flex" flexDirection="column" gap={1}>
      <Grid spacing={3} container>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "d/m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={startingTime.name}
            label={startingTime.label}
            error={errors.startingTime && touched.startingTime}
            success={values.startingTime?.toString().length > 0 && !errors.startingTime}
          />
        </Grid>
        <Grid item xs={6} style={{ paddingTop: 0 }}>
          <DatepickerField
            options={{
              dateFormat: "d-m-Y",
              plugins: [
                new monthSelectPlugin({
                  shorthand: true,
                  dateFormat: "d/m/Y",
                  theme: "light",
                }),
              ],
            }}
            name={timeOfChange.name}
            label={timeOfChange.label}
            error={errors.timeOfChange && touched.timeOfChange}
            success={values.timeOfChange?.toString().length > 0 && !errors.timeOfChange}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <FormField
            name={taxExemption.name}
            label={taxExemption.label}
            value={values.taxExemption}
            error={errors.taxExemption && touched.taxExemption}
            success={values.taxExemption?.toString().length > 0 && !errors.taxExemption}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <FormField
            name={compulsoryTax.name}
            label={compulsoryTax.label}
            value={values.compulsoryTax}
            error={errors.compulsoryTax && touched.compulsoryTax}
            success={values.compulsoryTax?.toString().length > 0 && !errors.compulsoryTax}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <FormField
            name={taxPrice.name}
            label={taxPrice.label}
            value={values.taxPrice}
            error={errors.taxPrice && touched.taxPrice}
            success={values.taxPrice?.toString().length > 0 && !errors.taxPrice}
          />
        </Grid>
        <Grid item xs={3} style={{ paddingTop: 0 }}>
          <FormField
            name={taxMustBePaid.name}
            label={taxMustBePaid.label}
            value={values.taxMustBePaid}
            error={errors.taxMustBePaid && touched.taxMustBePaid}
            success={values.taxMustBePaid?.toString().length > 0 && !errors.taxMustBePaid}
          />
        </Grid>
      </Grid>
    </Box>
  );
}
